<template>
  <el-row
    type="flex"
    justify="space-between"
    align="middle"
  >
    <div>
      <h1 class="card-container__title">{{ title }} <span class="card-container__subtitle">({{ total }})</span></h1>
    </div>
    <el-row
      class="card-container__actions"
      type="flex"
      justify="end"
      align="middle"
    >
      <el-button
        v-if="headerActions.includes('add')"
        type="primary"
        size="medium"
        icon="el-icon-plus"
        :disabled="disabled"
        :plain="plain"
        @click="$emit('create')"
      />
      <el-button
        v-if="headerActions.includes('reset')"
        class="ml-s"
        type="primary"
        size="medium"
        icon="el-icon-refresh"
        :plain="plain"
        :disabled="disabled"
        @click="$emit('refresh')"
      />
      <export-excel-button
        v-if="headerActions.includes('export')"
        class="ml-s"
        :title="title"
        :disabled="disabled || !columns.length"
        :total="total"
        :columns="columns"
        :object-type="objectType"
        :type="type"
        :filter-params="filterParams"
        :show-text="false"
      />
      <ImportExcelButton
        v-if="headerActions.includes('import')"
        class="ml-s"
        :title="title"
        :disabled="disabled || !columns.length"
        :total="total"
        :columns="columns"
        :object-type="objectType"
        :type="type"
        :show-text="false"
        :templates="importTemplates"
        @reload="() => $emit('refresh')"
      />
      <UpdateMutipleButton
        v-if="permission.UPDATE"
        class="ml-s"
        :disabled="disabled"
        :config="config"
        :selected-data="selectedData"
        @reload="() => $emit('refresh')"
      />
    </el-row>
  </el-row>
</template>

<script>
import ExportExcelButton from "@/components/buttons/ExportExcel.vue";
import ImportExcelButton from "@/components/buttons/ImportExcel.vue";
import UpdateMutipleButton from "@/components/buttons/UpdateMutiple.vue";

export default {
  name: "CardHeader",
  components: {
    ExportExcelButton,
    ImportExcelButton,
    UpdateMutipleButton
  },
  props: {
    config: Object,
    total: Number,
    disabled: Boolean,
    plain: Boolean,
    size: String,
    permission: Object,
    filterParams: Object,
    selectedData: Array,
    moduleInfo: Object
  },
  computed: {
    title() {
      if (!this.moduleInfo) {
        return this.config.extra.info.menu || "";
      }
      return this.moduleInfo.name
    },
    headerActions() {
      return (this.config.extra?.header_actions || []).filter((a) => {
        if (["add", "import"].includes(a)) {
          return this.permission.CREATE;
        }
        return true
      });
    },
    columns() {
      const data = this.config.extra?.fields || [];
      return data
        .filter((i) => i.show.import_export)
        .sort((a, b) => a.order - b.order);
    },
    objectType() {
      return this.config.type;
    },
    type() {
      return this.config.extra.key;
    },
    importTemplates() {
      return this.config.extra.import_templates || []
    }
  },
};
</script>

<style lang="scss" scoped></style>
